const storagePrefix = 'e_approval_'

const storage = {
  getUser: () => JSON.parse(window.localStorage.getItem(`${storagePrefix}user`)),
  setUser: (user) => {
    window.localStorage.setItem(`${storagePrefix}user`, JSON.stringify(user))
  },
  getToken: () => JSON.parse(window.localStorage.getItem(`${storagePrefix}token`)),
  setToken: (token) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token))
  },
  getRedirect: () => JSON.parse(window.localStorage.getItem(`${storagePrefix}redirect`)),
  setRedirect: (redirectObject) => {
    window.localStorage.setItem(`${storagePrefix}redirect`, JSON.stringify(redirectObject))
  },
  getLanguage: () => window.localStorage.getItem(`${storagePrefix}language`),
  setLanguage: (language) => {
    window.localStorage.setItem(`${storagePrefix}language`, language)
  },
  clear: () => {
    window.localStorage.removeItem(`${storagePrefix}user`)
    window.localStorage.removeItem(`${storagePrefix}token`)
  },
}

export default storage
